import '../Common.scss';
import { useLocation } from 'react-router-dom';
import Footer from '../../../components/Footer';
import SectionTabs from '../../../components/SectionTabs';
import GalleryGrid from '../../../components/GalleryGrid';
import { motion } from "framer-motion";

export const storyTabs = [
  { title: '프로그램', url: '/programImage' },
  { title: '기관소식지', url: '/newsImage' },
];

// 새삶이야기 (프로그램 · 기관소식지)
export default function G1_ProgramImage (props:any) {

  const location = useLocation();
  const isNews = location.pathname === '/newsImage';

  return (
    <div className="program-cover">

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.2 }}
      >
      <div>
        <SectionTabs title="새삶이야기" tabs={storyTabs}/>

        {
          isNews
          ? <GalleryGrid key="news" endpoint="/main/getgallerynews" emptyText="등록된 기관소식지가 없습니다."/>
          : <GalleryGrid key="program" endpoint="/main/getgalleryprogram" emptyText="등록된 프로그램이 없습니다."/>
        }
      </div>
      </motion.div>
      <Footer />
    </div>
  )
}
